interface RibbonProps {
  children: React.ReactNode;
}

export default function Ribbon({ children }: RibbonProps) {
  return (
    <div className="relative flex justify-center items-center py-4 px-2 bg-primary-500">
      <p className="text-center text-base text-white m-0">{children}</p>
    </div>
  );
}
